import { NgModule } from '@angular/core';
import {AlarmsComponent} from './alarms.component';
import { Routes, RouterModule } from '@angular/router';
import { Route } from '@app/core/route.service';

const routes: Routes = Route.withShell([
  { path: 'alarms', component: AlarmsComponent, data: { title: 'Alarms' } }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule],
  declarations: []
})
export class AlarmsRoutingModule { }
